// @flow
import React from "react";
import High from "../../../svg/facilities/is_high.svg";
import "./highIcon.scss";

const HighIcon = () => <High className="c-high-icon" />;

export default HighIcon;
